import { render, staticRenderFns } from "./VSimpleContributionStatus.vue?vue&type=template&id=3497b97a&"
import script from "./VSimpleContributionStatus.vue?vue&type=script&lang=ts&"
export * from "./VSimpleContributionStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports